import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import {UserDashboardPageContent, UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import {
    DashboardInformationCardElementComponent,
    DashboardStateCardElementComponent
} from "@Components/@Elements/@Cards";


import IconFilesS from "./@Icons/icon-files-s-orange.svg";
import IconUploadS_or from "./@Icons/icon-upload-s-orange.svg";
import IconFolderS from "./@Icons/icon-folder-s-orange.svg";
import IconStorageS from "./@Icons/icon-storage-s-orange.svg";

import IconTrashS from "./@Icons/icon-trash-s-grey.svg";
import IconUploadS_g from "./@Icons/icon-upload-s-grey.svg";
import IconFiltersS from "./@Icons/icon-filter-s-grey.svg";

import IconMoreS from "./@Icons/icon-more-s-black.svg";
import IconCheckS from "./@Icons/icon-check-s-green.svg";

import IconChevronLeftS from "./@Icons/icon-chevron_left-s-grey.svg";
import IconChevronRightS from "./@Icons/icon-chevron_right-s-grey.svg";


import "./index.scss";
import {ButtonComponent, FormDropdownComponent, InputComponent} from "@Components/Forms";
import BadgeElementComponent from "@Components/@Elements/@Badges";
import {SvgIconComponent} from "@Components/Elements";


export const UserDashboardDocumentsPage:React.FC = () => {

    return (
        <Container className={'user-dashboard-page-container'}>
            <Row className={'user-dashboard-page-container__content'}>

                <UserDashboardPageUserMenu />

                <UserDashboardPageContent
                    headingText={'Upload documents'}
                    descriptionText={'Upload, organize and preview your important documents'}
                >

                    <UserDashboardPageContentSection
                        sectionName={'user-documents-metrics'}
                    >

                        <DashboardInformationCardElementComponent
                            cardIcon={IconFilesS}
                            cardType={'state'} cardSize={'sm'}
                            cardHeaderText={'Total Documents'}
                            cardContentText={'247'}
                        />

                        <DashboardInformationCardElementComponent
                            cardIcon={IconUploadS_or}
                            cardType={'state'} cardSize={'sm'}
                            cardHeaderText={'This Month'}
                            cardContentText={'32'}
                        />

                        <DashboardInformationCardElementComponent
                            cardIcon={IconFolderS}
                            cardType={'state'} cardSize={'sm'}
                            cardHeaderText={'Categories'}
                            cardContentText={'12'}
                        />

                        <DashboardInformationCardElementComponent
                            cardIcon={IconStorageS}
                            cardType={'state'} cardSize={'sm'}
                            cardHeaderText={'Storage Used'}
                            cardContentText={'2.4 GB'}
                        />

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-documents-list'}
                    >

                        <Col xs={12} className={'user-documents-list-header'}>
                            <Row className={'user-documents-list-header__content'}>
                                <Col xs={12} lg={6} className={'user-documents-list-header__header-text'}>
                                    <span>Document list</span>
                                </Col>
                                <Col xs={12} lg={6} className={'user-documents-list-header__header-options'}>
                                    <ButtonComponent text={'Remove selected'} type={'flat'} iconLeft={IconTrashS} bordered={true} buttonDisabled={true} />
                                    <ButtonComponent text={'Upload document'} iconLeft={IconUploadS_g} buttonDisabled={true} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-documents-list-filters'}>
                            <Row className={'user-documents-list-filters__content'}>
                                <Col xs={12} lg={5} className={'user-documents-list-filters__search-documents'}>
                                    <InputComponent
                                        xl={8}
                                        value={''} setValue={() => undefined}
                                        placeholder={'Search documents...'}
                                        disabled={true}
                                    />
                                </Col>
                                <Col xs={6} lg={3} className={'user-documents-list-filters__category-filter'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'All Categories' }]} optionChoiceHandler={() => undefined}
                                        selectedOptionID={1}
                                        fieldDisabledStatus={true}
                                    />
                                </Col>
                                <Col xs={4} lg={3} className={'user-documents-list-filters__sort-options'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'Sort by date' }]} optionChoiceHandler={() => undefined}
                                        selectedOptionID={1}
                                        fieldDisabledStatus={true}
                                    />
                                </Col>
                                <Col xs={2} lg={1} className={'user-documents-list-filters__submit-filters'}>
                                    <ButtonComponent
                                        text={''}
                                        type={'flat'} size={'l'} iconLeft={IconFiltersS} bordered={true}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-documents-list-elements'}>
                            <Row>

                                <Col xs={12} className={'user-documents-list-elements__list-header'}>
                                    <Row className={'user-documents-list-elements__list-header__content'}>
                                        <Col className={'documents-list-element-check'}></Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Name</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <span>Category</span>
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>Size</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Uploaded date</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span>Actions</span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-documents-list-elements__list-element'}>
                                    <Row className={'user-documents-list-elements__list-element__content'}>
                                        <Col className={'documents-list-element-check'}>
                                            <span className={'checkbox-element-component'}></span>
                                        </Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Document1.pdf</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <BadgeElementComponent
                                                badgeType={'info'} badgeSize={'md'} badgeText={'info'}
                                                badgeIcon={false}
                                            />
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>1.2 MB</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Dec 15, 2024</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span className={'documents-list-element-actions__actions-button'}>
                                                <SvgIconComponent iconSource={IconMoreS} />
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-documents-list-elements__list-element'}>
                                    <Row className={'user-documents-list-elements__list-element__content'}>
                                        <Col className={'documents-list-element-check'}>
                                            <span className={'checkbox-element-component checkbox-element-component--checked-element'}>
                                                <SvgIconComponent iconSource={IconCheckS} className={'checkbox-element-icon'} />
                                            </span>
                                        </Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Document2.pdf</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'} badgeText={'invoice'}
                                                badgeIcon={false}
                                            />
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>1.2 MB</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Dec 15, 2024</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span className={'documents-list-element-actions__actions-button'}>
                                                <SvgIconComponent iconSource={IconMoreS}/>
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-documents-list-elements__list-element'}>
                                    <Row className={'user-documents-list-elements__list-element__content'}>
                                        <Col className={'documents-list-element-check'}>
                                            <span className={'checkbox-element-component'}></span>
                                        </Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Document3.pdf</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <BadgeElementComponent
                                                badgeType={'warning'} badgeSize={'md'} badgeText={'Insurance'}
                                                badgeIcon={false}
                                            />
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>1.2 MB</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Dec 15, 2024</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span className={'documents-list-element-actions__actions-button'}>
                                                <SvgIconComponent iconSource={IconMoreS} className={'checkbox-element-icon'} />
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-documents-list-elements__list-element'}>
                                    <Row className={'user-documents-list-elements__list-element__content'}>
                                        <Col className={'documents-list-element-check'}>
                                            <span className={'checkbox-element-component'}></span>
                                        </Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Document4.pdf</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <BadgeElementComponent
                                                badgeType={'error'} badgeSize={'md'} badgeText={'Receipt'}
                                                badgeIcon={false}
                                            />
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>1.2 MB</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Dec 15, 2024</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span className={'documents-list-element-actions__actions-button'}>
                                                <SvgIconComponent iconSource={IconMoreS}/>
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'user-documents-list-elements__list-element'}>
                                    <Row className={'user-documents-list-elements__list-element__content'}>
                                        <Col className={'documents-list-element-check'}>
                                            <span
                                                className={'checkbox-element-component checkbox-element-component--checked-element'}>
                                                <SvgIconComponent iconSource={IconCheckS} />
                                            </span>
                                        </Col>
                                        <Col className={'documents-list-element-name'}>
                                            <span>Document5.pdf</span>
                                        </Col>
                                        <Col className={'documents-list-element-category'}>
                                            <BadgeElementComponent
                                                badgeType={'paused'} badgeSize={'md'} badgeText={'Contract'}
                                                badgeIcon={false}
                                            />
                                        </Col>
                                        <Col className={'documents-list-element-size'}>
                                            <span>1.2 MB</span>
                                        </Col>
                                        <Col className={'documents-list-element-upload-date'}>
                                            <span>Dec 15, 2024</span>
                                        </Col>
                                        <Col className={'documents-list-element-actions'}>
                                            <span className={'documents-list-element-actions__actions-button'}>
                                                <SvgIconComponent iconSource={IconMoreS}/>
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                        <Col xs={12} className={'pagination-element-component'}>
                            <Row className={'pagination-element-component__content'}>

                                <Col xs={12} lg={4} className={'pagination-element-component__pagination-label'}>
                                    <span>Showing 1 to 5 of 275 documents</span>
                                </Col>

                                <Col xs={12} lg={8} className={'pagination-element-component__pagination-list'}>
                                    <Row className={'pagination-element-component__pagination-list__content'}>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button pagination-element-component__pagination-list__pagination-button--previous-button'}>
                                            <ButtonComponent
                                                text={'Previous'}
                                                type={'flat'} bordered={true} iconLeft={IconChevronLeftS}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button pagination-element-component__pagination-list__pagination-button--active-button'}>
                                            <ButtonComponent
                                                text={'1'}
                                                type={'flat'} bordered={true}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button'}>
                                            <ButtonComponent
                                                text={'2'}
                                                type={'flat'} bordered={true}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button'}>
                                            <ButtonComponent
                                                text={'3'}
                                                type={'flat'} bordered={true}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button pagination-element-component__pagination-list__pagination-button--separator-button'}>
                                            <ButtonComponent text={'...'} type={'flat'} bordered={true} />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button'}>
                                            <ButtonComponent
                                                text={'50'}
                                                type={'flat'} bordered={true}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                        <Col xs={'auto'} className={'pagination-element-component__pagination-list__pagination-button pagination-element-component__pagination-list__pagination-button--next-button'}>
                                            <ButtonComponent
                                                text={'Next'}
                                                type={'flat'} bordered={true} iconRight={IconChevronRightS}
                                                buttonDisabled={true}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                </UserDashboardPageContent>

            </Row>
        </Container>
    );

};


export default UserDashboardDocumentsPage;
